
import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
  async createNewProfile(context, payload = {}) {
    try {
      let resp = await axios.post(Constants.aiPersonalitiesUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[createNewProfile][Store][Error occured while creating new profile--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getPersoanlitiesDataFromServer(context, payload = {}) {
      try {
        let tempUrl =  Constants.aiPersonalitiesUrl;
        // if("personalityId" in payload){
        //   tempUrl = tempUrl + "/" +  payload.personalityId;
        //   // tempUrl = tempUrl+"/856e553d-d219-498d-818c-5ea2e5fdc766"
        // }

        if('params' in payload){
          // this.$set(payload['params'], 'limit', 50)
          payload['params']['limit'] = 50;
        }else{
          payload['params'] = {limit:50}
        }

        let resp = await axios.get(tempUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
          resp.data.statusCode = resp.status
          return resp.data;
        }else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
      } catch (error) {
        console.error(
          `[getServerfaceDetectionDataData][Store][Error occured while getServerfaceDetectionDataData report list--->${error}]`
        );
        if (error.response) {
          if (error.response.status == 401){
            return context.dispatch("users/logOutFromServer", {},{root:true})
          }
          else {
            error.response.data.statusCode = error.response.status
            return error.response.data
          }
        }
        return {}
      }
  },
  
  async getIndividualPersoanlityDataFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.aiPersonalitiesUrl+'/'+payload.personalityId, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getIndividualPersoanlityDataFromServer][Store][Error occured while getIndividualPersoanlityDataFromServer report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getDataSetDataFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.dataSetPersonalitiesUrl+'/'+payload.personalityId+"/data_set", payload.params);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getDataSetDataFromServer][Store][Error occured while getDataSetDataFromServer report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteFileFromDataSetFromServer(context, payload = {}) {
    try {
        let resp = await axios.delete(`${Constants.dataSetPersonalitiesUrl+'/'+payload.personalityId+"/data_set/"+payload.version_id}`, payload.params);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[deleteFileFromDataSetFromServer][Store][Category Delete resp-->${resp.status}]`
            );
            context.commit("setCategoriesinfo", {})
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[deleteFileFromDataSetFromServer][Store][Error occured while deleting Category--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }

  },

  async updateIndPersonalityFromServe(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.aiPersonalitiesUrl+'/'+payload.personalityId, payload.params);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateIndPersonalityFromServe][Store][Error occured while updating asset version info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update asset version info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async removePersonality(context, payload = {}) {
    try {
      let resp = await axios.delete(`${Constants.aiPersonalitiesUrl}/${payload.params._id}`);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[removePersonality][Store][Error occured while removing new profile--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async removePersonalityFromTagfaces(context, payload = {}) {
    try {
      let resp = await axios.delete(`${Constants.aiPersonalitiesUrl}/${payload.personalityId}/files/${payload.fileUid}`);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[removePersonality][Store][Error occured while removing new profile--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  
  async getFaceDetectionConfigDataFromServer(context, payload = {}) {
    try {
      let url = Constants.faceDetectionPluginConfigUrl;
      let resp = await axios.get(url, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getFaceDetectionConfigDataFromServer][Store][Error occured while getFaceDetectionConfigDataFromServer report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
} 

